<template>
  <div v-if="isToggle" class="row q-pa-sm">
    <div
      class="c col-xs-4 ol-sm-2 col-md-2"
      v-for="(item, index) in optimizedCheckboxData"
      :key="index"
    >
      <q-checkbox
        v-model="checkboxStates[item.value]"
        color="blue"
        keep-color
        :label="item.name"
      >
        <q-tooltip class="bg-primary">{{ item.tooltip }}</q-tooltip>
      </q-checkbox>
    </div>
  </div>
</template>
<script>
import { ref, watch, computed, onMounted } from "vue";
import useData from "src/use/data";
import { useStore } from "vuex";
export default {
  emits: [
    "selectedIndIcatorSymbol",
    "selectedIndIcatorValue",
    "selectedIndIcatorDate",
  ],
  props: {
    isToggle: { type: Boolean },
  },
  setup(props, context) {
    const data = ref([]);
    const asOf = ref("");
    const store = useStore();

    const { indicatorsAll } = useData();

    const fetchData = async () => {
      asOf.value = store.state.market.asOf;
      const res = await indicatorsAll(asOf.value);
      data.value = res.data;
    };



    watch(
      () => props.isToggle,
      (newVal, oldVal) => {
        if (newVal === true){
          fetchData();
        }
      },
    );

    const checkboxData = [
      "sma20_y_n",
      "sma50_y_n",
      "sma200_y_n",
      "sma5_20_y_n",
      "sma5_50_y_n",
      "sma5_200_y_n",
      "sma20_50_y_n",
      "sma20_200_y_n",
      "sma50_200_y_n",
      //   "swing_r_y_n",
      //   "swing_r1_y_n",
      //   "swing_r2_y_n",
      //   "pivot_y_n",
      //   "pivot_s1_y_n",
      //   "pivot_s2_y_n",
      //   "pivot_s3_y_n",
      //   "pivot_r1_y_n",
      //   "pivot_r2_y_n",
      //   "pivot_r3_y_n",
      "low_bb_y_n",
      "high_bb_y_n",
      "middle_bb_y_n",
      "macd_diff_y_n",
      //   "macd_y_n",
      //   "macd_signal_y_n",
      "di_pos_y_n",
      "adx_y_n",
      "supertrend_10_1_y_n",
      "supertrend_11_2_y_n",
      "supertrend_12_3_y_n",
      "ema9_y_n",
      "ema21_y_n",
      "ema55_y_n",
      "ema9_21_y_n",
      "ema9_55_y_n",
    ];

    const optimizedCheckboxData = [
      {
        name: "sma20",
        value: "sma20_y_n",
        tooltip: "close price above 20 days SMA",
      },
      {
        name: "sma50",
        value: "sma50_y_n",
        tooltip: "close price above 50 days SMA",
      },
      {
        name: "sma200",
        value: "sma200_y_n",
        tooltip: "close price above 200 days SMA",
      },
      {
        name: "sma5_20",
        value: "sma5_20_y_n",
        tooltip: "5 days SMA above 20 days SMA",
      },
      {
        name: "sma5_50",
        value: "sma5_50_y_n",
        tooltip: "5 days SMA above 50 days SMA",
      },
      {
        name: "sma5_200",
        value: "sma5_200_y_n",
        tooltip: "5 days SMA above 200 days SMA",
      },
      {
        name: "sma20_50",
        value: "sma20_50_y_n",
        tooltip: "20 days SMA above 50 days SMA",
      },
      {
        name: "sma20_200",
        value: "sma20_200_y_n",
        tooltip: " 20 days SMA above 200 days SMA",
      },

      {
        name: "sma50_200",
        value: "sma50_200_y_n",
        tooltip: " 50 days SMA above 200 days SMA",
      },
      {
        name: "low_bb",
        value: "low_bb_y_n",
        tooltip: " close price below lower BB",
      },
      {
        name: "high_bb",
        value: "high_bb_y_n",
        tooltip: " close price above high BB",
      },
      {
        name: "middle_bb",
        value: "middle_bb_y_n",
        tooltip: " close price above middle BB",
      },
      { name: "macd_diff", value: "macd_diff_y_n", tooltip: "  macd positive" },
      {
        name: "di_pos",
        value: "di_pos_y_n",
        tooltip: "  Di negative above Di positive",
      },
      { name: "adx", value: "adx_y_n", tooltip: " adx above 22.5" },
      {
        name: "supertrend_10_1",
        value: "supertrend_10_1_y_n",
        tooltip: " close price below supertrend (10,1)",
      },
      {
        name: "supertrend_11_2",
        value: "supertrend_11_2_y_n",
        tooltip: " close price below supertrend (11,2)",
      },
      {
        name: "supertrend_12_3",
        value: "supertrend_12_3_y_n",
        tooltip: " close price below supertrend (12,3)",
      },
      {
        name: "ema9",
        value: "ema9_y_n",
        tooltip: " close price above 9 days EMA",
      },
      {
        name: "ema21",
        value: "ema21_y_n",
        tooltip: " close price above 21 days EMA",
      },
      {
        name: "ema55",
        value: "ema55_y_n",
        tooltip: " close price above 55 days EMA",
      },
      {
        name: "ema9_21",
        value: "ema9_21_y_n",
        tooltip: "  9 days EMA above 21 days EMA",
      },
      {
        name: "ema9_55",
        value: "ema9_55_y_n",
        tooltip: " 9 days EMA above 55 days EMA",
      },
    ];

    const checkboxStates = ref(
      Object.fromEntries(checkboxData.map((item) => [item, false]))
    );

    const trueValues = computed(() =>
      Object.keys(checkboxStates.value).filter(
        (key) => checkboxStates.value[key]
      )
    );

    const filteredSymbols = computed(() =>
      data.value
        .filter((item) => trueValues.value.every((key) => item[key] === "Y"))
        .map((i) => i.symbol)
    );

    watch(
      () => filteredSymbols.value,
      (newVal, oldVal) => {
        if (newVal != undefined) {
          context.emit("selectedIndIcatorSymbol", newVal);
          context.emit("selectedIndIcatorValue", trueValues.value);
          context.emit("selectedIndIcatorDate", asOf.value);
        }
      }
    );

    return {
      checkboxStates,
      checkboxData,
      trueValues,
      data,
      filteredSymbols,
      optimizedCheckboxData,
    };
  },
};
</script>
